module.exports = __webpack_public_path__ + "static/media/background-l9.e8bf05f2.png";